module.exports = __webpack_public_path__ + "static/media/10.8bb43025.svg";